import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal, Spin } from "antd";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
const ConsignmentCancelModal = (props) => {
    const [form] = Form.useForm();
    const [stateLoading, setStateLoading] = useState(false);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    useEffect(() => {
        if (!props.open) {
            // If we are being hidden clean field content in preparation for next use
            setStateErrorMessage(null);
            form.setFieldsValue({
                reason: ''
            });
        }
    }, [props.open]);
    const onFinish = (formValues) => {
        cancelConsignment(formValues.reason);
    };
    const cancelConsignment = (reason) => {
        setStateLoading(true);
        axios(`/admin/v1/consignments/${props.consignmentId}`, {
            method: 'DELETE',
            params: {
                reason: reason,
                consignmentVersion: props.consignmentVersion
            }
        }).then(( /*response*/) => {
            props.onConsignmentCancelled(props.consignmentId);
        }).catch((error) => {
            if (isConcurrentModificationError(error)) {
                setStateErrorMessage("The delivery could not be cancelled. This is because another user has modified the same delivery.  Please refresh the delivery list and try again.");
            }
            else {
                axiosErrorHandler(error, setStateErrorMessage);
            }
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsx(Modal, { title: "Cancel Delivery", open: props.open, onOk: form.submit, onCancel: props.onCancel, confirmLoading: stateLoading, destroyOnHidden: true, children: _jsxs(Spin, { spinning: stateLoading, children: [_jsx(Form, { form: form, onFinish: onFinish, children: _jsx(Form.Item, { label: "Reason", name: "reason", rules: [{
                                required: true,
                                message: 'A reason is required.',
                            }], children: _jsx(Input.TextArea, { placeholder: "Reason", rows: 3 }) }) }), stateErrorMessage ?
                    _jsx(Alert, { title: stateErrorMessage, type: "error", showIcon: true }) : null] }) }));
};
export default ConsignmentCancelModal;
